import { useState } from "react";
import { faqs } from "@/mocks/data";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.6fr] lg:gap-16">
          <div>
            <div className="mb-3 text-sm font-medium text-secondary-700">
              <i className="ri-question-line mr-2"></i>
              常见问题
            </div>
            <h2 className="font-heading text-2xl leading-snug text-foreground-950 md:text-4xl">
              关于吃瓜每日,
              <br />
              你可能想问
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              还没开始还不清楚怎么玩?先看这里。如果仍有疑问,也可以随时联系我们,我们会第一时间回复。
            </p>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600"
            >
              联系瓜小编
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="space-y-3">
            {faqs.map((f, idx) => {
              const isOpen = open === idx;
              return (
                <div
                  key={f.q}
                  className={`rounded-2xl bg-background-100 ring-1 ring-background-200 transition-colors ${
                    isOpen ? "bg-background-100" : ""
                  }`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : idx)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className="text-sm font-semibold text-foreground-900 md:text-base">
                      {f.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-lg transition-transform ${
                        isOpen ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i className="ri-add-line"></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}